import React, { SVGProps } from 'react';

export const ClipboardCheckIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      {...props}
    >
      <g fill="currentColor">
        <path
          d="M8 2.5h.5c1 0 1.5.5 1.5 1.5v5c0 1-.5 1.5-1.5 1.5h-5C2.5 10.5 2 10 2 9V4c0-1 .5-1.5 1.5-1.5H4"
          opacity=".4"
        />
        <path d="M8 2.25v.5c0 .5-.25.75-.75.75h-2.5c-.5 0-.75-.25-.75-.75v-.5c0-.5.25-.75.75-.75h2.5c.5 0 .75.25.75.75ZM5.583 7.875a.372.372 0 0 1-.265-.11l-.833-.833a.375.375 0 1 1 .53-.53l.569.567 1.401-1.401a.375.375 0 0 1 .53.53L5.85 7.765a.374.374 0 0 1-.266.11Z" />
      </g>
    </svg>
  );
};
